/**
 * Type pour le genre/civilité d'un contact
 */
export type ContactGender = 
  | 'mr'
  | 'me'
  | 'ste'
  | 'sci';

/**
 * Labels d'affichage pour les genres/civilités de contact
 */
export const CONTACT_GENDER_LABELS: Record<ContactGender, string> = {
  mr: 'Mr',
  me: 'Me',
  ste: 'Sté',
  sci: 'SCI'
};

/**
 * Type pour la désignation/classification d'un contact
 */
export type ContactDesignation = 
  | 'contact'
  | 'proprietaire'
  | 'proprietaire_vendeur'
  | 'prospect_acquereur'
  | 'client_acquereur';

/**
 * Labels d'affichage pour les désignations de contact
 */
export const CONTACT_DESIGNATION_LABELS: Record<ContactDesignation, string> = {
  contact: 'Contact',
  proprietaire: 'Propriétaire',
  proprietaire_vendeur: 'Propriétaire vendeur',
  prospect_acquereur: 'Prospect acquéreur',
  client_acquereur: 'Client acquéreur'
};

/**
 * Interface représentant un contact dans l'application
 */
export interface Contact {
  id: string;
  markerId: string;  // Référence au marqueur associé
  user_id?: string;  // ID de l'utilisateur qui a créé le contact
  agency_id?: string; // ID de l'agence à laquelle appartient le contact
  gender?: ContactGender; // Civilité du contact (Mr, Me, Sté, SCI)
  name?: string;
  firstName?: string;
  address?: string;  // Rue et numéro (ex: "50 rue nationale")
  postalCode?: string; // Code postal (ex: "59000")
  city?: string;     // Ville (ex: "Lille")
  phone?: string;
  email?: string;
  notes?: string;
  designation?: ContactDesignation; // Classification du contact
  createdAt?: Date;
  updatedAt?: Date;
}

/**
 * Interface pour les données nécessaires à la création d'un contact
 */
export type ContactCreateInput = Omit<Contact, 'id' | 'createdAt' | 'updatedAt'>;

/**
 * Interface pour les données de mise à jour d'un contact
 */
export type ContactUpdateInput = Partial<ContactCreateInput>;

